"use client";
import useTranslate from "@app/_hooks/useTranslate";
import { Button } from "@components/ui";
import { useHeaderContext } from "@context/headerContext";
import { MobileMenuContext } from "@context/mobileMenuContext";
import { DialogTitle } from "@ui/dialog";
import { ChevronLeft as ArrowLeftIcon } from "lucide-react";
import { useContext } from "react";

export default function MobileMenuHeader() {
  const t = useTranslate();
  useHeaderContext();
  const { navigationTree, setNavigationTree, setNavigationDirection } =
    useContext(MobileMenuContext);

  const isSubMenuActive = navigationTree.length > 1;

  if (isSubMenuActive) {
    return (
      <DialogTitle>
        <Button
          className="all-small-caps flex items-center tracking-wider"
          onClick={() => {
            setNavigationDirection("left");
            setNavigationTree((prev) => {
              if (prev.length === 1) return prev;

              return prev.slice(0, prev.length - 1);
            });
          }}
        >
          <ArrowLeftIcon strokeWidth={1} className="mr-1 size-4.5" />
          {t("back")}
        </Button>
      </DialogTitle>
    );
  }

  return (
    <DialogTitle className="all-small-caps tracking-wider">
      {t("menu")}
    </DialogTitle>
  );
}
